import { PageType, PageTypes } from 'strapi/page/types';
import { RequestParams } from 'strapi/types';

import { CarouselStrapiComponent } from './types';

export const carouselParams: (
  type: PageType
) => RequestParams<PageTypes & { carousel: CarouselStrapiComponent }> = (
  _: PageType
) => ({
  populate: {
    carousel: {
      populate: {
        create_use_case_pages: {
          populate: {
            use_case: true,
            cover: true,
          },
        },
        templates_use_case_pages: {
          populate: {
            use_case: {
              fields: ['slug', 'name'],
            },
          },
        },
        templates_sub_use_case_pages: {
          populate: {
            sub_use_case: {
              fields: ['slug', 'name'],
              populate: {
                use_case: {
                  fields: ['slug'],
                },
              },
            },
          },
        },
      },
    },
  },
});
